<section class="flex min-h-screen w-full items-center justify-center">
  <section class="flex w-full max-w-6xl overflow-hidden rounded-xl bg-white shadow-xl">

    <!-- Illustration -->
    <div class="hidden md:flex md:w-1/2 items-center justify-center bg-gray-100">
      <img
        src="/images/register.svg"
        alt="Illustration connexion"
        class="max-h-80"
      />
    </div>

    <!-- Form -->
    <div class="w-full md:w-1/2 py-8 px-12">
      <img src="/images/attestio-logo.png" alt="logo" class="h-14 mx-auto mb-4" />

      @if (registered()) {
        <div class="space-y-6 text-center">
          <div class="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto">
            <span class="material-symbols-outlined text-green-600 text-3xl">mark_email_read</span>
          </div>
          <h2 class="text-2xl font-bold text-gray-900">Vérifiez votre e-mail</h2>
          <p class="text-gray-600">
            Un e-mail de vérification a été envoyé à <strong>{{ email() }}</strong>.
            Cliquez sur le lien dans l'e-mail pour activer votre compte.
          </p>
          <p class="text-sm text-gray-500">
            Si vous ne trouvez pas l'e-mail, <b>vérifiez vos spams</b>.
          </p>
          <a
            routerLink="/login"
            class="inline-block w-full h-11 leading-[2.75rem] rounded-lg bg-secondary text-white font-semibold hover:bg-secondary-hover transition-colors"
          >
            Aller à la connexion
          </a>
        </div>
      } @else {

      <h2 class="text-2xl font-bold mb-6 text-center">
        Créer un compte
      </h2>

      <form (ngSubmit)="register()" class="space-y-4">

        <div class="space-y-2">
          <span class="text-sm font-medium text-gray-700">Type de compte</span>
          <div class="grid grid-cols-2 gap-3">
            <button
              type="button"
              (click)="role.set(Role.EXECUTIVE)"
              class="rounded-xl border-2 p-4 text-center transition-all cursor-pointer"
              [class.border-secondary]="role() === Role.EXECUTIVE"
              [class.bg-secondary/5]="role() === Role.EXECUTIVE"
            [class.border-[hsl(210_20%_90%)]]="role() !== Role.EXECUTIVE"
            [class.hover:border-[hsl(213_15%_46%/0.3)]]="role() !== Role.EXECUTIVE"
            >
            <span class="material-symbols-outlined mx-auto mb-2 text-[24px] cursor-pointer"
                  [class.text-secondary]="role() === Role.EXECUTIVE"
                  [class.text-[hsl(213_15%_46%)]]="role() !== Role.EXECUTIVE">
                apartment
              </span>
            <div class="text-sm font-medium text-[hsl(213_55%_15%)]">Entreprise</div>
            <div class="text-[10px] text-[hsl(213_15%_46%)] mt-1">Gérez vos attestations</div>
            </button>

            <button
              type="button"
              (click)="role.set(Role.ACCOUNTANT)"
              class="rounded-xl border-2 p-4 text-center transition-all cursor-pointer"
              [class.border-secondary]="role() === Role.ACCOUNTANT"
              [class.bg-secondary/5]="role() === Role.ACCOUNTANT"
            [class.border-[hsl(210_20%_90%)]]="role() !== Role.ACCOUNTANT"
            [class.hover:border-[hsl(213_15%_46%/0.3)]]="role() !== Role.ACCOUNTANT"
            >
            <span class="material-symbols-outlined mx-auto mb-2 text-[24px]"
                  [class.text-secondary]="role() === Role.ACCOUNTANT"
                  [class.text-[hsl(213_15%_46%)]]="role() !== Role.ACCOUNTANT">
                calculate
              </span>
            <div class="text-sm font-medium text-[hsl(213_55%_15%)]">Expert-comptable</div>
            <div class="text-[10px] text-[hsl(213_15%_46%)] mt-1">Gérez vos clients</div>
            </button>
          </div>
        </div>

        <!-- Prénom / Nom -->
        <div class="columns-2">
          <div>
            <label for="firstName" class="block text-sm font-medium text-gray-700">
              Prénom
            </label>
            <input
              id="firstName"
              type="text"
              class="mt-1 w-full rounded-md border border-gray-300 px-3 py-2
                   focus:border-secondary focus:ring focus:ring-secondary/25"
              [value]="firstName()"
              (input)="firstName.set($any($event.target).value)"
              required
              autocomplete="given-name"
            />
          </div>

          <div>
            <label for="lastName" class="block text-sm font-medium text-gray-700">
              Nom
            </label>
            <input
              id="lastName"
              type="text"
              class="mt-1 w-full rounded-md border border-gray-300 px-3 py-2
                   focus:border-secondary focus:ring focus:ring-secondary/25"
              [value]="lastName()"
              (input)="lastName.set($any($event.target).value)"
              required
              autocomplete="family-name"
            />
          </div>
        </div>

        @if (role() === Role.ACCOUNTANT) {
          <div>
            <label for="cabinetName" class="block text-sm font-medium text-gray-700">
              Nom du cabinet
            </label>
            <input
              id="cabinetName"
              type="text"
              class="mt-1 w-full rounded-md border border-gray-300 px-3 py-2
                   focus:border-secondary focus:ring focus:ring-secondary/25"
              [value]="cabinetName()"
              (input)="cabinetName.set($any($event.target).value)"
              required
              autocomplete="organization"
              placeholder="Cabinet Dupont & Associés"
            />
          </div>
          <div>
            <label for="cabinetPhone" class="block text-sm font-medium text-gray-700">
              Téléphone du cabinet
            </label>
            <input
              id="cabinetPhone"
              type="tel"
              class="mt-1 w-full rounded-md border border-gray-300 px-3 py-2
                   focus:border-secondary focus:ring focus:ring-secondary/25"
              [value]="cabinetPhone()"
              (input)="cabinetPhone.set($any($event.target).value)"
              required
              autocomplete="tel"
              placeholder="01 23 45 67 89"
            />
          </div>
          <div>
            <label for="cabinetEmail" class="block text-sm font-medium text-gray-700">
              Email du cabinet
            </label>
            <input
              id="cabinetEmail"
              type="email"
              class="mt-1 w-full rounded-md border border-gray-300 px-3 py-2
                   focus:border-secondary focus:ring focus:ring-secondary/25"
              [value]="cabinetEmail()"
              (input)="cabinetEmail.set($any($event.target).value)"
              required
              autocomplete="email"
              placeholder="contact@cabinet.fr"
            />
          </div>
        }

        <!-- Email -->
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">
            Adresse email
          </label>
          <input
            id="email"
            type="email"
            class="mt-1 w-full rounded-md border border-gray-300 px-3 py-2
                   focus:border-secondary focus:ring focus:ring-secondary/25"
            [value]="email()"
            (input)="email.set($any($event.target).value)"
            required
            autocomplete="email"
          />
        </div>

        <!-- Mot de passe -->
        <div>
          <label for="password" class="block text-sm font-medium text-gray-700">
            Mot de passe
          </label>
          <input
            id="password"
            type="password"
            class="mt-1 w-full rounded-md border border-gray-300 px-3 py-2
                   focus:border-secondary focus:ring focus:ring-secondary/25"
            [value]="password()"
            (input)="password.set($any($event.target).value)"
            required
            autocomplete="new-password"
          />
        </div>

        @if (password().length > 0 && !isPasswordValid()) {
          <p class="text-xs text-red-500">
            Le mot de passe doit contenir au moins 8 caractères, une majuscule,
            une minuscule, un chiffre et un caractère spécial.
          </p>
        }

        <!-- Mot de passe -->
        <div>
          <label for="confirmPassword" class="block text-sm font-medium text-gray-700">
            Confirmation du mot de passe
          </label>
          <input
            id="confirmPassword"
            type="password"
            class="mt-1 w-full rounded-md border border-gray-300 px-3 py-2
                   focus:border-secondary focus:ring focus:ring-secondary/25"
            [value]="confirmPassword()"
            (input)="confirmPassword.set($any($event.target).value)"
            required
            autocomplete="new-password"
          />
        </div>

        @if (confirmPassword().length > 0 && !passwordsMatch()) {
          <p class="text-xs text-red-500">
            Les mots de passe ne correspondent pas
          </p>
        }

        <!-- Error -->
        @if (error().length > 0) {
          <p class="text-red-500 text-sm text-center">
            {{error()}}
          </p>
        }

        <!-- Divider -->
        <div class="my-6 flex items-center">
          <div class="flex-grow border-t"></div>
        </div>

        <!-- Submit -->
        <button
          type="submit"
          class="w-full h-11 rounded-lg bg-secondary text-secondary-foreground font-semibold cursor-pointer
                 hover:bg-secondary-hover transition-colors duration-150 disabled:opacity-60 disabled:cursor-not-allowed"
          [disabled]="!isFormValid() || loading()"
        >
          @if (loading()) {
            Création du compte...
          } @else {
            S’inscrire
          }
        </button>

      </form>

      <!-- Link to login -->
      <p class="text-sm text-center mt-4">
        Déjà un compte ?
        <a routerLink="/login" class="text-secondary hover:underline">
          Se connecter
        </a>
      </p>

      }
    </div>
  </section>
</section>
